export default "__VITE_ASSET__DPxB$x3D__"